export const PLAN_CREATE_ROUTE = '/plans/create';
